import { IAndroidWatchesFormState } from './androidWatchesFormContext';
import { AndroidWatchesFormActionsTypes, TAndroidWatchesFormAction } from './androidWatchesFormAction';

export const androidWatchesFormReducer = (
	state: IAndroidWatchesFormState,
	action: TAndroidWatchesFormAction,
): IAndroidWatchesFormState => {
	switch (action.type) {
		case AndroidWatchesFormActionsTypes.SET_MESSAGES:
			return {
				...state,
				importantMessages: action.payload.importantMessages,
				informationMessages: action.payload.informationMessages,
			};
		case AndroidWatchesFormActionsTypes.SET_IMPORTANT_MESSAGES:
			return {
				...state,
				importantMessages: action.payload.importantMessages,
			};
		case AndroidWatchesFormActionsTypes.SET_INFORMATION_MESSAGES:
			return {
				...state,
				informationMessages: action.payload.informationMessages,
			};
		case AndroidWatchesFormActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case AndroidWatchesFormActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
